import { BaseSectionProps } from "../types/landingSections";
import { Mail, Phone } from "lucide-react";
import { SvgWhatsapp } from "@/icons";

const ContactSection: React.FC<BaseSectionProps> = ({ section }) => {
    const props = section?.props ?? {};

    const phone = props.phone;
    const email = props.correo_perfil;
    const whatsapp = props.whatsapp ?? "";

    const title = props.title ?? "¿Necesitas ayuda?";
    const subtitle =
        props.subtitle ??
        "Ponte en contacto y recibe atención personalizada para tu proyecto o servicio.";

    const cleanWhatsapp = whatsapp.replace(/\D/g, "");

    const hasContact = !!phone || !!email || !!cleanWhatsapp;

    if (!hasContact) return null;

    const baseBtn =
        "w-14 h-14 flex items-center justify-center rounded-full transition-all duration-300 hover:scale-110 backdrop-blur-md";

    return (
        <section className="py-20 px-6">
            <div className="max-w-5xl mx-auto">

                <div
                    className="
                        rounded-[40px]
                        border border-cyan-500/60
                        bg-white/[0.04]
                        backdrop-blur-xl
                        p-10 sm:p-14
                        text-center
                    "
                >

                    {/* TITLE */}
                    <h2 className="text-3xl sm:text-4xl font-bold">
                        {title}
                    </h2>

                    {/* SUBTITLE */}
                    <p className="text-white/60 mt-4 max-w-2xl mx-auto">
                        {subtitle}
                    </p>

                    {/* BUTTONS */}
                    <div className="mt-10 flex justify-center gap-6 flex-wrap">

                        {phone && (
                            <a
                                href={`tel:${phone}`}
                                className={`${baseBtn}
                                    bg-cyan-500/10
                                    border border-cyan-500/30
                                    hover:bg-cyan-500/20
                                    shadow-[0_0_20px_rgba(0,255,255,0.08)]
                                `}
                            >
                                <Phone size={20} className="text-cyan-300" />
                            </a>
                        )}

                        {email && (
                            <a
                                href={`mailto:${email}`}
                                className={`${baseBtn}
                                    bg-white/[0.06]
                                    border border-white/10
                                    hover:bg-white/[0.12]
                                `}
                            >
                                <Mail size={20} className="text-white/80" />
                            </a>
                        )}

                        {cleanWhatsapp && (
                            <a
                                href={`https://wa.me/${cleanWhatsapp}`}
                                target="_blank"
                                rel="noreferrer"
                                className={`${baseBtn}
                                    bg-green-500/10
                                    border border-green-500/30
                                    hover:bg-green-500/20
                                    shadow-[0_0_20px_rgba(34,197,94,0.12)]
                                `}
                            >
                                <SvgWhatsapp
                                    width={20}
                                    height={20}
                                    className="text-green-400"
                                />
                            </a>
                        )}

                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;